import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Table, Label, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Loader from 'components/layout/Loader';
import IntlDateTime from 'components/layout/IntlDateTime';

import List from 'components/List';

import ContentDiff from 'components/modals/ContentDiff';

class CmsTemplateHistory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDiff: false,
      diffHistory: null,
    };
  }

  handleClick = diffHistory => {
    this.setState({ showDiff: true, diffHistory });
  };

  closeDiff = () => {
    this.setState({ showDiff: false });
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      list,
    } = this.props;
    const { showDiff, diffHistory } = this.state;

    const columns = [messages.date, messages.user, 'diff', messages.actions];
    const tBody = list.data.list.map((history, i) => {
      const countAdded = history.diff.added.length;
      const countRemoved = history.diff.removed.length;
      const countEdited = history.diff.edited.length;
      const countMoved = history.diff.moved.length;

      return (
        <tr key={history.id} onClick={() => this.handleClick(history)}>
          <td className="v-align-middle semi-bold">
            <IntlDateTime date={history.cdate} />
          </td>
          <td className="v-align-middle">{history.public_creator.name}</td>
          <td className="v-align-middle">
            <OverlayTrigger placement="top" overlay={<Tooltip id={history.id + '-added'}>New elements</Tooltip>}>
              <Label bsStyle="success" className={'fs-24 ' + (!countAdded ? 'hint-text ' : '')}>
                <i className="fal fa-plus-square" /> {countAdded}
              </Label>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip id={history.id + '-removed'}>Removed elements</Tooltip>}>
              <Label bsStyle="danger" className={'fs-24 m-l-10 ' + (!countRemoved ? 'hint-text ' : '')}>
                <i className="fal fa-minus-square" /> {countRemoved}
              </Label>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip id={history.id + '-edited'}>Edited elements</Tooltip>}>
              <Label bsStyle="primary" className={'fs-24 m-l-10 ' + (!countEdited ? 'hint-text ' : '')}>
                <i className="fal fa-edit" /> {countEdited}
              </Label>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip id={history.id + '-moved'}>Moved elements</Tooltip>}>
              <Label bsStyle="info" className={'fs-24 m-l-10 ' + (!countMoved ? 'hint-text ' : '')}>
                <i className="fal fa-arrow-square-right" /> {countMoved}
              </Label>
            </OverlayTrigger>
          </td>
          <td className="v-align-middle text-right">
            <Button bsSize="sm" className="btn-rounded m-r-10">
              <i className="fa fa-pencil-alt" /> {messages.view}
            </Button>
          </td>
        </tr>
      );
    });

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return entityLoaded ? (
      <List
        listName="cmsTemplateHistory"
        url={`/api/pagetemplates/${entity.getId()}/history.json`}
        list={list}
        title={null}
        sortOptions={['cdate,desc']}
        showSearch={false}
      >
        {resultTable}

        <div id="content-diff">
          <ContentDiff show={showDiff} close={this.closeDiff} history={diffHistory} />
        </div>
      </List>
    ) : (
      <Loader />
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.list.cmsTemplateHistory,
  };
};

export default injectIntl(connect(mapStateToProps)(CmsTemplateHistory));
